import { createQueryData } from '../helpers/createQueryData';

const { useQuery: useCompaniesQuery } = createQueryData({
  endPoint: 'Acceptance/get_service_companies',
});

export { useCompaniesQuery };
